export interface TaskTypeEntry {
  task_type: string;
  source_name: string;
}

export interface TaskTypeMapping {
  id?: string | null;
  mapping_type: string;
  company_id: string;
  integration: string;
  mappings: Record<string, TaskTypeEntry>;
}

export interface IntegrationTaskTypeName {
  locale: string;
  name: string;
}

export type IntegrationTaskTypeSource = "calendar" | "activity";

export interface IntegrationTaskType {
  id: string;
  names: IntegrationTaskTypeName[];
  source?: IntegrationTaskTypeSource;
}

export interface TaskTypesApiResponse {
  company: string;
  task_types: IntegrationTaskType[];
  count: number;
}

export const compassTaskTypeGroups = [
  {
    label: "Visit",
    types: ["visit", "visit_office", "visit_cancelled", "visitday", "visit_generic_office", "visit_generic_onsite"],
  },
  {
    label: "Visit-Request",
    types: ["visit_request"],
  },
  {
    label: "Inboundlead",
    types: [
      "buy_in",
      "buy_in_office",
      "rent_in",
      "estimation_buy_in",
      "estimation_rent_in",
      "present_estimation_buy_in",
      "present_estimation_rent_in",
    ],
  },
];

export const compassTaskTypes = compassTaskTypeGroups.flatMap((g) => g.types);
